import controller from './box-text-template.controller';
import templateBase from './templates/box-text-template-base.html';


let BoxTextTemplate = {
    template: changeTemplate,
    controller,
    bindings: {
        shCtrl: '<',
        page: '@'
    }
};

changeTemplate.$inject = ['SessionService'];

function changeTemplate(SessionService) {
    //let response = SessionService.get('components');
    return templateBase;
}

export default BoxTextTemplate





/** WEBPACK FOOTER **
 ** C:/wamp64/www/FRONTENDS/PROYECTOS SIESA/Projects_Azure/motos_paisa/NUEVO/motos-y-motos-el-paisa/www/components/box-text-template/box-text-template.component.js
 **/